import { useBreakpointContext } from '../../../Utils/context-providers/BreakpointContext';
import { convertPropsToStyle } from '../grid';
const useConvertProps = props => {
  const {
    matchedBreakpoints = ['S']
  } = useBreakpointContext() || {};
  const {
    gridStyles,
    reactProps
  } = convertPropsToStyle(matchedBreakpoints, props);
  return {
    gridStyles,
    reactProps
  };
};
export default useConvertProps;